export var BI_SOURCES;
(function (BI_SOURCES) {
    BI_SOURCES[BI_SOURCES["VOD_SRC_ID"] = 71] = "VOD_SRC_ID";
})(BI_SOURCES || (BI_SOURCES = {}));
//# sourceMappingURL=sources.js.map